import { Box, Button, Flex, Heading, VStack } from '@chakra-ui/react';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useMst, useServerAPI } from '../../../../setup/root';
import { EulaContent } from '../../../shared/eula-content';

export const EULAScreen = observer(function EULAScreen({ withClose }: { withClose?: boolean }) {
  const { userStore } = useMst();
  const api = useServerAPI();
  const { eula } = userStore;
  const navigate = useNavigate();

  const { handleSubmit, formState } = useForm();
  const { isLoading, isValid } = formState;

  const onSubmit = async () => {
    if (userStore.currentUser) {
      // Authenticated user - accept EULA in database
      await userStore.currentUser.acceptEULA();
    } else {
      // Non-registered user - create contractor and accept EULA
      try {
        // Step 1: Create contractor via shim endpoint
        const shimResponse = await api.createContractorShim();

        if (!shimResponse.ok || !shimResponse.data?.data) {
          throw new Error('Failed to create contractor');
        }

        const contractor = shimResponse.data.data;

        // Step 2: Accept EULA for contractor
        const eulaResponse = await api.acceptEULA(contractor.id);

        if (eulaResponse.ok) {
          // Store contractor ID for potential future use
          localStorage.setItem('contractorId', contractor.id);
        } else {
          throw new Error('Failed to accept EULA');
        }
      } catch (error) {
        console.error('Error in contractor EULA flow:', error);
      }
    }
  };

  useEffect(() => {
    const fetch = async () => {
      await userStore.fetchEULA();
    };
    !eula && fetch();
  }, [eula]);

  const navHeight = document.getElementById('mainNav')?.offsetHeight;

  const onClose = () => {
    window.history.state && window.history.state.idx > 0 ? navigate(-1) : navigate(`/profile`);
  };

  return (
    <>
      <VStack
        as="main"
        id="main-content"
        tabIndex={-1}
        direction="column"
        spacing={8}
        py={20}
        w="full"
        h={`calc(100vh - ${navHeight}px)`}
      >
        <Heading as="h1" m={0} flex={0} flexBasis="auto" color="theme.blueAlt">
          {t('eula.title')}
        </Heading>
        {eula && (
          <>
            <Box maxW="4xl" w="full" overflow="hidden">
              <Box h="100%" overflow="auto" border="1px solid" borderColor="border.light" borderRadius="6px">
                <EulaContent content={eula.content} p="1rem" />
              </Box>
            </Box>
            {(userStore.currentUser && !userStore.currentUser.eulaAccepted) || !userStore.currentUser ? (
              <form onSubmit={handleSubmit(onSubmit)} style={{ flex: 0, flexBasis: 'auto' }}>
                <Button variant="primary" type="submit" isLoading={isLoading} isDisabled={!isValid || isLoading}>
                  {t('eula.accept')}
                </Button>
              </form>
            ) : null}
          </>
        )}
      </VStack>
      {withClose && (
        <Flex
          justify="flex-end"
          w="full"
          bg="greys.grey03"
          position="sticky"
          bottom={0}
          px={4}
          py={2.5}
          zIndex={10}
          borderWidth={1}
          borderColor="border.light"
          shadow="drop"
        >
          <Button variant={'secondary'} onClick={onClose}>
            {t('ui.close')}
          </Button>
        </Flex>
      )}
    </>
  );
});
